<style lang="scss"></style>

<template>
  <article class="content dashboard-page">
    <div class="title-block">
      <h3 class="title">Consultar Pedidos</h3>
    </div>

    <div class="row">
      <div class="col-md-12">
        <form @submit.prevent="filterData(1)">
          <div class="card card-block">
            <div class="row form-group">
              <div class="form-group m0 col-md-9">
                <label class="control-label">Cliente</label>
                <input type="text" class="form-control underlined" v-model.trim="filters.client" />
              </div>

              <div
                class="form-group m0 col-md-3"
                :class="{ 'has-error': $v.filters.document.$error }"
              >
                <label class="control-label">CPF/CNPJ</label>
                <the-mask
                  class="form-control underlined"
                  v-model.trim="$v.filters.document.$model"
                  :mask="['###.###.###-##', '##.###.###/####-##']"
                />
                <template v-if="$v.filters.document.$dirty">
                  <span
                    v-if="!$v.filters.document.isCPFCNPJValid"
                    class="has-error aasd"
                  >CPF/CNPJ inválido</span>
                </template>
              </div>
            </div>

            <div class="row form-group">
              <div class="form-group m0 col-md-3">
                <label class="control-label">Num. Pedido</label>
                <input type="text" class="form-control underlined" v-model.trim="filters.num" />
              </div>

              <div class="form-group m0 col-md-3">
                <label class="control-label">OP Pedido</label>
                <input type="text" class="form-control underlined" v-model.trim="filters.numOP" />
              </div>

              <div class="form-group m0 col-md-6">
                <label class="control-label">Vendedor</label>
                <input type="text" class="form-control underlined" v-model.trim="filters.seller" />
              </div>
            </div>

            <div class="row form-group">
              <div class="form-group m0 col-md-3">
                <label class="control-label">Protocolo</label>
                <input type="text" class="form-control underlined" v-model.trim="filters.prot" />
              </div>

              <div class="form-group m0 col-md-6">
                <label class="control-label">Data</label>
                <div class="row">
                  <div class="col-md-5">
                    <vc-date-picker
                      v-model="dateStart"
                      locale="pt-BR"
                      :max-date="dateEnd"
                      :popover="{ placement: 'bottom', visibility: 'click' }"
                    >
                      <input
                        type="tel"
                        v-mask="'##/##/####'"
                        class="form-control underlined"
                        slot-scope="{ inputProps, inputEvents }"
                        v-bind="inputProps"
                        v-on="inputEvents"
                      />
                    </vc-date-picker>
                  </div>
                  <div class="col-md-2 text-center">
                    <p class="p0 m0" style="margin-top: 7px;">até</p>
                  </div>
                  <div class="col-md-5">
                    <vc-date-picker
                      v-model="dateEnd"
                      locale="pt-BR"
                      :min-date="dateStart"
                      :popover="{ placement: 'bottom', visibility: 'click' }"
                    >
                      <input
                        type="tel"
                        v-mask="'##/##/####'"
                        class="form-control underlined"
                        slot-scope="{ inputProps, inputEvents }"
                        v-bind="inputProps"
                        v-on="inputEvents"
                      />
                    </vc-date-picker>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group text-right m0">
              <button
                type="submit"
                class="btn btn-primary m0"
                :disabled="enviando"
              >{{ enviando ? "BUSCANDO..." : "BUSCAR" }}</button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div v-if="result" class="row">
      <div class="col-md-12">
        <div class="card card-block">
          <div class="title-block">
            <h3 class="title">
              {{ result.count }}
              {{ result.count > 1 ? "PEDIDOS ENCONTRADO" : "PEDIDO ENCONTRADO" }}
            </h3>
          </div>

          <div class="row form-group">
            <div class="form-group m0 col-md-11"></div>
            <div class="form-group m0 col-md-1 pl0">
              <select
                class="c-select form-control underlined"
                v-model="filters.limit"
                @change="filterData(1)"
              >
                <option value>Qtd</option>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>

          <div class="form-group">
            <table class="table table-striped">
              <thead class="thead-inverse">
                <tr>
                  <th width="15%">#</th>
                  <th width="20%">Num. Pedido</th>
                  <th width="35%">Cliente</th>
                  <th width="20%">CPF/CNPJ</th>
                  <th width="10%"></th>
                </tr>
              </thead>
              <tbody v-if="result &&
                     result.data.length > 0">
                <tr
                  v-for="item in result.data"
                  :key="item.id"
                  v-tooltip="{
                        content: montarTooltip(item),
                        placement: 'left',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip']
                      }"
                >
                  <th scope="row">
                    <router-link
                      :to="{ name: 'pedido-detalhes',
                          params: { id: item.id } }"
                      class="link-detalhes text-info"
                    >{{ item.protocolo }}</router-link>
                  </th>
                  <td>{{ item.numPedido }}</td>
                  <td>{{ item.cliente }}</td>
                  <td>{{ item.documento }}</td>
                  <td>
                    <router-link
                      target="_blank"
                      :to="{ name: 'cliente-pedidos',
                          params: { id: item.clienteId } }"
                      class="btn btn-sm btn-info-outline m0"
                      :class="{ disabled: !item.clienteId }"
                    >ABRIR</router-link>&nbsp;
                  </td>
                </tr>
              </tbody>
              <tfoot v-if="result.data.length <= 0">
                <tr>
                  <td colspan="7">
                    <p class="m0 p0 text-center">Nenhum pedido encontrado!</p>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div v-if="result.pages > 1" class="form-group text-right">
            <paginate
              v-model="result.page"
              :page-count="result.pages"
              :click-handler="nextPrevPage"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :prev-class="'page-item'"
              :next-class="'page-item'"
              :page-link-class="'page-link'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
            ></paginate>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import moment from 'moment';

import Paginate from 'vuejs-paginate';
import { isCPFCNPJValid, showLoading, closeLoading } from '../../../helpers';

import AuthService from '../../../services/AuthService';
import PedidoService from '../../../services/PedidoService';

export default {
  name: 'pedido-relatorios',
  components: {
    Paginate,
  },
  created() {
    if (Object.keys(this.$route.query).length > 0) {
      const {
        page,
        limit,
        document,
        client,
        seller,
        num,
        numOP,
        start,
        end,
      } = this.$route.query;
      this.filters.page = page;
      this.filters.limit = limit;
      this.filters.document = document;
      this.filters.client = client;
      this.filters.seller = seller;
      this.filters.num = num;
      this.filters.numOP = numOP;
      this.filters.start = start;
      this.filters.end = end;
    }

    this.load();
  },
  data() {
    return {
      detalhePedidoId: null,
      pedidoId: null,
      enviando: false,
      exportando: false,
      dateStart: null,
      dateEnd: null,
      result: null,
      filters: {
        page: 1,
        limit: 5,
        document: '',
        client: '',
        seller: '',
        num: '',
        numOP: '',
        start: '',
        end: '',
      },
    };
  },
  validations: {
    filters: {
      document: {
        isCPFCNPJValid,
      },
    },
  },
  watch: {
    dateStart(date) {
      if (!date) {
        this.filters.start = '';
        return;
      }

      this.filters.start = moment(date).format('DD/MM/YYYY');
    },
    dateEnd(date) {
      if (!date) {
        this.filters.end = '';
        return;
      }

      this.filters.end = moment(date).format('DD/MM/YYYY');
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return '-';

      return moment(date, 'DD/MM/YYYY hh:mm:ss').format('DD/MM/YY');
    },
    montarTooltip(pedido) {
      let tooltip = '';

      tooltip += `<b>Vendedor:</b><br/> ${pedido.vendedor}`;
      tooltip += `<br/><br/> <b>Data do Pedido:</b><br/> ${this.formatDate(
        pedido.dataPedido,
      )}`;
      tooltip += `<br/><br/> <b>Data de Entrega:</b><br/> ${this.formatDate(
        pedido.dataEntrega,
      )}`;
      tooltip += `<br/><br/> <b>Faturamento:</b><br/> ${pedido.faturamento}`;
      tooltip += `<br/><br/> <b>OPs:</b><br/> ${pedido.itens}`;

      return tooltip;
    },
    async load() {
      try {
        showLoading();
        this.result = await PedidoService.findAll(this.filters);
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();
      }
    },
    async filterData(page) {
      this.$v.filters.$touch();

      if (this.$v.filters.$invalid) return;

      try {
        this.enviando = true;

        this.filters.page = page;

        this.$router.push({ query: this.filters });

        showLoading();

        this.result = await PedidoService.findAll(this.filters);
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        this.enviando = false;
      }
    },
    nextPrevPage(page) {
      this.filterData(page);
    },
    view(item) {
      this.detalhePedidoId = item;
    },
  },
  computed: {
    isVendedor() {
      return AuthService.isVendedor();
    },
  },
};
</script>
